const ads = init => store => {
  store.on('@init', () => ({ ads: {slots: init, loaded: []} }));
  store.on('ads/add', (state, data) => ({ ads: {...state.ads, loaded: state.ads.loaded.concat(data)}}));
};

export default ads;
